// RevenueCharts.tsx (with proper monthly filtering)
import ChartAreaInteractive from '@/components/UI/Charts/AreaChart'
import { useGetTransactionsMonthlyStatsQuery } from '@/services/api/transaction/transactionApi'
import React from 'react'

export default function RevenueCharts() {
  const { data: apiResponse, isLoading } = useGetTransactionsMonthlyStatsQuery()
  
  // Transform API data to chart format
  const chartData = apiResponse?.monthly_data?.map((item) => {
    // Use JavaScript's built-in Date parsing
    const date = new Date(`${item.month} 1, 2024`)
    const monthNum = String(date.getMonth() + 1).padStart(2, '0')
    
    return {
      date: `2024-${monthNum}-01`,
      Revenue: item.total_amount,
      Orders: item.total_orders,
    }
  }) || []

  const revenueConfig = {
    Revenue: {
      label: "Revenue (₦)",
      color: "#fb923c",
    },
    Orders: {
      label: "Orders",
      color: "#3b82f6",
    },
  }

  if (isLoading) {
    return <div className="p-6">Loading chart...</div>
  }

  if (!chartData.length) {
    return <div className="p-6 text-gray-500">No data available</div>
  }

  return (
    <div>
      <ChartAreaInteractive
        data={chartData}
        title="Revenue & Orders Overview"
        description={`Total: ₦${apiResponse?.total_amount_so_far?.toLocaleString() || 0} | ${apiResponse?.total_orders_so_far || 0} orders`}
        config={revenueConfig}
        height="400px"
        timeRangeOptions={[
          { value: "365d", label: "Year to date" },
          { value: "180d", label: "Last 6 months" },
          { value: "90d", label: "Last 3 months" },
        ]}
      />
    </div>
  )
}